<button class="p1"
        uiAccordionTrigger
        uiButton>
    <span class="flex flex-middle"
          [style.gap.px]="8">
        <multisite-flag [country]="current.country" />
        <p>{{current.name}}&nbsp;{{current.currency}}</p>
    </span>
    <i class="icon-chevron-down-24"
       aria-hidden="true"></i>
</button>
<div class="p1"
     uiAccordionContent>
    @for (item of all; track $index) {
    <a [attr.href]="getRedirectLink($any(item)) || $any(item).url"
       (click)="goTo($any(item), $event)">
        <!-- current.country -->
        <multisite-flag [country]="item.country" />
        {{item.name}}&nbsp;({{item.currency}})
    </a>
    }
</div>